import React from 'react';
import { FiFileText, FiAlertCircle, FiArrowRight } from 'react-icons/fi';

export default function GuidanceAndImportantCards() {
  return (
    <div className="w-[280px] space-y-4 font-sans select-none">
      
      {/* 1. Guidance Card */}
      <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm space-y-4">
        <h3 className="text-gray-900 font-bold text-base tracking-tight text-left">
          Guidance
        </h3>
        
        <div className="text-blue-950/70 text-xs font-normal leading-relaxed text-left space-y-4">
          <p>
            Review allergen information monthly and whenever there are menu or supplier changes.
          </p>
          <p>
            Ensure all controls are effective and staff are confident in managing allergens.
          </p>
          <p>
            If you find any issues, log an incident immediately and take corrective action.
          </p>
        </div>

        <button className="w-full flex items-center justify-center space-x-2 py-2.5 border border-blue-200 rounded-xl bg-white hover:bg-blue-50/50 active:bg-blue-50 text-xs font-bold text-blue-600 transition shadow-sm">
          <FiFileText className="w-4 h-4" />
          <span>View Allergen SOP</span>
        </button>
      </div>

      {/* 2. Important Alert Card */}
      <div className="bg-orange-50/40 rounded-2xl p-6 border border-orange-100/70 space-y-4">
        <div className="flex items-center space-x-2 text-orange-700">
          <FiAlertCircle className="w-5 h-5 flex-shrink-0" />
          <h3 className="font-bold text-base tracking-tight">
            Important
          </h3>
        </div>

        <div className="text-orange-950/80 text-xs font-normal leading-relaxed text-left space-y-4">
          <p>
            Allergen management is a legal requirement.
          </p>
          <p>
            Ensure accuracy and clear communication to protect customers and prevent incidents.
          </p>
        </div>

        <button className="w-full flex items-center justify-between px-4 py-2.5 border border-orange-200/60 rounded-xl bg-white hover:bg-orange-50/30 active:bg-orange-50 text-xs font-bold text-blue-700 transition shadow-sm">
          <span className="mx-auto pl-4">Log Incident</span>
          <FiArrowRight className="w-4 h-4 text-blue-700 flex-shrink-0" />
        </button>
      </div>

    </div>
  );
}
